import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import TutorLessonScreen from './TutorLessonScreen'
import TutorChoseDeviceScreen from './TutorChoseDeviceScreen'
import PresenceReporter from './PresenceReporter'
// import { RootReducer } from '../redux/rootReducer'
import { FETCH_TUTOR } from '../redux/tutorReducer'
import Layout from './Layout'

const TutorLessonScreenWrapper = () => {
  const [screen, setScreen] = useState<'chose-device' | 'lesson'>('chose-device')
  const dispatch = useDispatch()
  // const isStudentPresent = useSelector((state: RootReducer) => state.tutorChannelReducer.isStudentPresent)

  // useEffect(() => {
  //   if (!isStudentPresent) {
  //     setScreen('chose-device')
  //   }
  // }, [isStudentPresent, dispatch])

  useEffect(() => {
    dispatch(FETCH_TUTOR())
  }, [dispatch])

  return (
    <Layout withWrapper={false}>
      <div>
        {screen === 'lesson' && <TutorLessonScreen />}
        {screen === 'chose-device' && <TutorChoseDeviceScreen setScreen={setScreen} />}
        <PresenceReporter screen={screen} />
      </div>
    </Layout>
  )
}

export default TutorLessonScreenWrapper
